export const venueNames = {
  default: '/images/png/default.png',
  Acme: '/images/stores/acme.png',
  Ahold: '/images/stores/ahold.png', // name not found in venues
  "Aj's": '/images/stores/ajs.png',
  Albertsons: '/images/stores/albertsons.png',
  Amigos: '/images/stores/amigos.png',
  Bashas: '/images/stores/bashas.png',
  'Bed Bath Beyond': '/images/stores/bedbath.png',
  'Bed Bath & Beyond': '/images/stores/bedbath.png',
  'Harmon + Bed Bath & Beyond': '/images/stores/bedbath.png',
  'Buy Buy Baby': '/images/stores/buybuybaby.png',
  'CBL Properties': '/images/stores/cvs.png', // name not found in venues
  CVS: '/images/stores/cvs.png', // name not found in venues
  'Eddie’s Country Store': '/images/png/default.png', // name not found in venues and image
  'Food City': '/images/stores/food-city.png',
  'Food 4 Less': '/images/stores/food4less.png',
  GGP: '/images/stores/ggp.png',
  Giant: '/images/stores/giant.png',
  'Giant Food': '/images/stores/giantfood.png',
  'Harris Teeter': '/images/stores/harris-teeter.png',
  'Hen House City': '/images/stores/henhouse.png', // name not found in venues
  HEB: '/images/stores/heb.png',
  'H Mart Federal Way': '/images/stores/hmart.png',
  'H Mart Bellevue': '/images/stores/hmart.png',
  'H Mart Lynnwood': '/images/stores/hmart.png',
  'H Mart UW': '/images/stores/hmart.png',
  'Hy-Vee': '/images/stores/hyvee.png',
  Jewel: '/images/stores/jewelosco.png',
  'Kinney Drugs': '/images/stores/kinneydrugs.png',
  Kroger: '/images/stores/kroger.png',
  'Kroger Fresh Fare': '/images/stores/kroger.png',
  'Kroger Marketplace': '/images/stores/kroger.png',
  'LA Fitness': '/images/stores/la-fitness.png',
  Marianos: '/images/stores/marianos.png',
  Michaels: '/images/stores/michaels.png',
  Navarro: '/images/stores/navarro.png',
  'Navarro Discount Pharmacy': '/images/stores/navarro.png',
  Pavilions: '/images/stores/pavilions.png', // name not found in venues
  'Pick N Save': '/images/stores/picknsave.png',
  'Piggly Wiggly': '/images/stores/pigglywiggly.png',
  'Piggly Wiggly- Franklin': '/images/stores/pigglywiggly.png',
  'Piggly Wiggly-Columbia-Nashville': '/images/stores/pigglywiggly.png',
  'Piggly Wiggly Columbia-Trotwood': '/images/stores/pigglywiggly.png',
  Raleys: '/images/stores/raleys.png', // name not found in venues
  Ralphs: '/images/stores/ralphs.png',
  'Ralphs Fresh Fare': '/images/stores/ralphs.png',
  Randalls: '/images/stores/randalls.png',
  "Randall's": '/images/stores/randalls.png',
  'Rite Aid': '/images/stores/riteaid.png',
  'Roche Bros Supermarkets': '/images/stores/rochebros.png',
  'Rosauers Food & Drug Center': '/images/stores/rosauers.png',
  'Rosauers Supermarkets': '/images/stores/rosauers.png',
  Rondys: '/images/stores/roundys.png', // name not found in venues
  'Rouse Properties': '/images/stores/rouseproperties.png', // name not found in venues
  'Rouses Market': '/images/stores/rousesmarkets.png',
  Safeway: '/images/stores/safeway.png',
  'Sedanos Supermarkets': '/images/stores/sedanos.png',
  Shaws: '/images/stores/shaws.png',
  "Simon's Pharmacy": '/images/stores/simon.png',
  "Smith's": '/images/stores/smiths.png',
  "Smith's Marketplace": '/images/stores/smiths.png',
  'Stater Bros': '/images/stores/staterbros.png', // name not found in venues
  'Stop & Shop': '/images/stores/stopshopfood.png',
  'Stop N Shop': '/images/stores/stopshopfood.png',
  'Tom Thumb': '/images/stores/tomthumb.png',
  Tops: '/images/stores/tops.png', // name not found in venues
  United: '/images/stores/unitedsupermarkets.png',
  VONS: '/images/stores/vons.png', // name not found in venues
  Walgreens: '/images/stores/walgreens.png',
  Winco: '/images/stores/winco.png',
  'Winn-Dixie': '/images/stores/winndixie.jpg', // name not found in venues
  "Woodman's": '/images/stores/woodmans.png',
};

export const venueTypes = {
  supermarket: {
    name: 'Supermarket',
    image: '/images/stores/types/supermarket.png',
    pinColor: '#0b57f1',
  },
  drugstore: {
    name: 'DrugStore',
    image: '/images/stores/types/drugstore.png',
    pinColor: '#f10b0b',
  },
  mall: {
    name: 'Mall',
    image: '/images/stores/types/mall.png',
    pinColor: '#e878d7',
  },
  healthclub: {
    name: 'Health Club',
    image: '/images/stores/types/healthclub.png',
    pinColor: '#e9dd17',
  },
  cstore: {
    name: 'CS Store',
    image: '/images/stores/types/cstore.png',
    pinColor: '#ee661c',
  },
  entertainment: {
    name: 'Entertainment',
    image: '/images/stores/types/entertainment.png',
    pinColor: '#b92af5',
  },
  retail: {
    name: 'Retail',
    image: '/images/stores/types/retail.png',
    pinColor: '#03c04a',
  },
  default: {
    name: 'Other',
    image: '/images/png/default.png',
    pinColor: '#32612d',
  },
};

export const venueRank = {
  bronze: 'bronze',
  silver: 'silver',
  gold: 'gold',
  platinum: 'platinum',
  copper: 'copper',
  diamond: 'diamond',
};

export const venueMonthlyPriceTier = {
  [venueRank.bronze]: 299,
  [venueRank.silver]: 349,
  [venueRank.gold]: 399,
  [venueRank.platinum]: 499,
  [venueRank.diamond]: 600,
  default: 349,
};

export const venueAnnualPriceTier = {
  [venueRank.bronze]: 199,
  [venueRank.silver]: 239,
  [venueRank.gold]: 299,
  [venueRank.platinum]: 429,
  [venueRank.diamond]: 515,
  default: 325,
};

export const venueDigitalPriceTier = {
  [venueRank.diamond]: 300,
  [venueRank.platinum]: 40,
  [venueRank.gold]: 30,
  [venueRank.silver]: 20,
  [venueRank.bronze]: 15,
  [venueRank.copper]: 10,
  default: 20,
};

export const rankColors = {
  [venueRank.bronze]: {
    label: venueRank.bronze.toUpperCase(),
    color: 'rgba(182, 82, 0, 0.8)',
    bgColor: 'rgba(221, 178, 166, 0.3)',
  },
  [venueRank.silver]: {
    label: venueRank.silver.toUpperCase(),
    color: 'rgba(115, 118, 120, 0.8)',
    bgColor: 'rgba(238, 238, 238, 0.8)',
  },
  [venueRank.gold]: {
    label: venueRank.gold.toUpperCase(),
    color: '#ffc107',
    bgColor: '#fff8e1',
  },
  [venueRank.platinum]: {
    label: venueRank.platinum.toUpperCase(),
    color: 'rgba(61, 0, 123, 0.7)',
    bgColor: 'rgba(230, 230, 250, 0.85)',
  },
  [venueRank.diamond]: {
    label: venueRank.diamond.toUpperCase(),
    color: '#2072C3',
    bgColor: '#B9F2FF',
  },
};
